/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as ArchitectureRouteImport } from './routes/architecture'
import { Route as DataSourcesRouteImport } from './routes/data-sources'
import { Route as OrgChartRouteImport } from './routes/org-chart'
import { Route as PodcastsRouteImport } from './routes/podcasts'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as SkillsRouteImport } from './routes/skills'
import { Route as AgentAgentTypeRouteImport } from './routes/agent.$agentType'
import { Route as ConnectorsIndexRouteImport } from './routes/connectors.index'
import { Route as ConnectorsRetrievalPathsRouteImport } from './routes/connectors.retrieval-paths'
import { Route as HrScreenerRouteImport } from './routes/hr.screener'
import { Route as ItSignatureRouteImport } from './routes/it.signature'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchitectureRoute = ArchitectureRouteImport.update({
  id: '/architecture',
  path: '/architecture',
  getParentRoute: () => rootRouteImport,
} as any)
const DataSourcesRoute = DataSourcesRouteImport.update({
  id: '/data-sources',
  path: '/data-sources',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgChartRoute = OrgChartRouteImport.update({
  id: '/org-chart',
  path: '/org-chart',
  getParentRoute: () => rootRouteImport,
} as any)
const PodcastsRoute = PodcastsRouteImport.update({
  id: '/podcasts',
  path: '/podcasts',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsRoute = SkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentAgentTypeRoute = AgentAgentTypeRouteImport.update({
  id: '/agent/$agentType',
  path: '/agent/$agentType',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectorsIndexRoute = ConnectorsIndexRouteImport.update({
  id: '/connectors/',
  path: '/connectors/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectorsRetrievalPathsRoute =
  ConnectorsRetrievalPathsRouteImport.update({
    id: '/connectors/retrieval-paths',
    path: '/connectors/retrieval-paths',
    getParentRoute: () => rootRouteImport,
  } as any)
const HrScreenerRoute = HrScreenerRouteImport.update({
  id: '/hr/screener',
  path: '/hr/screener',
  getParentRoute: () => rootRouteImport,
} as any)
const ItSignatureRoute = ItSignatureRouteImport.update({
  id: '/it/signature',
  path: '/it/signature',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agents': typeof AgentsRoute
  '/architecture': typeof ArchitectureRoute
  '/data-sources': typeof DataSourcesRoute
  '/org-chart': typeof OrgChartRoute
  '/podcasts': typeof PodcastsRoute
  '/projects': typeof ProjectsRoute
  '/skills': typeof SkillsRoute
  '/agent/$agentType': typeof AgentAgentTypeRoute
  '/connectors/retrieval-paths': typeof ConnectorsRetrievalPathsRoute
  '/hr/screener': typeof HrScreenerRoute
  '/it/signature': typeof ItSignatureRoute
  '/connectors/': typeof ConnectorsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agents': typeof AgentsRoute
  '/architecture': typeof ArchitectureRoute
  '/data-sources': typeof DataSourcesRoute
  '/org-chart': typeof OrgChartRoute
  '/podcasts': typeof PodcastsRoute
  '/projects': typeof ProjectsRoute
  '/skills': typeof SkillsRoute
  '/agent/$agentType': typeof AgentAgentTypeRoute
  '/connectors/retrieval-paths': typeof ConnectorsRetrievalPathsRoute
  '/hr/screener': typeof HrScreenerRoute
  '/it/signature': typeof ItSignatureRoute
  '/connectors': typeof ConnectorsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agents': typeof AgentsRoute
  '/architecture': typeof ArchitectureRoute
  '/data-sources': typeof DataSourcesRoute
  '/org-chart': typeof OrgChartRoute
  '/podcasts': typeof PodcastsRoute
  '/projects': typeof ProjectsRoute
  '/skills': typeof SkillsRoute
  '/agent/$agentType': typeof AgentAgentTypeRoute
  '/connectors/retrieval-paths': typeof ConnectorsRetrievalPathsRoute
  '/hr/screener': typeof HrScreenerRoute
  '/it/signature': typeof ItSignatureRoute
  '/connectors/': typeof ConnectorsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agents'
    | '/architecture'
    | '/data-sources'
    | '/org-chart'
    | '/podcasts'
    | '/projects'
    | '/skills'
    | '/agent/$agentType'
    | '/connectors/retrieval-paths'
    | '/hr/screener'
    | '/it/signature'
    | '/connectors/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agents'
    | '/architecture'
    | '/data-sources'
    | '/org-chart'
    | '/podcasts'
    | '/projects'
    | '/skills'
    | '/agent/$agentType'
    | '/connectors/retrieval-paths'
    | '/hr/screener'
    | '/it/signature'
    | '/connectors'
  id:
    | '__root__'
    | '/'
    | '/agents'
    | '/architecture'
    | '/data-sources'
    | '/org-chart'
    | '/podcasts'
    | '/projects'
    | '/skills'
    | '/agent/$agentType'
    | '/connectors/retrieval-paths'
    | '/hr/screener'
    | '/it/signature'
    | '/connectors/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgentsRoute: typeof AgentsRoute
  ArchitectureRoute: typeof ArchitectureRoute
  DataSourcesRoute: typeof DataSourcesRoute
  OrgChartRoute: typeof OrgChartRoute
  PodcastsRoute: typeof PodcastsRoute
  ProjectsRoute: typeof ProjectsRoute
  SkillsRoute: typeof SkillsRoute
  AgentAgentTypeRoute: typeof AgentAgentTypeRoute
  ConnectorsRetrievalPathsRoute: typeof ConnectorsRetrievalPathsRoute
  HrScreenerRoute: typeof HrScreenerRoute
  ItSignatureRoute: typeof ItSignatureRoute
  ConnectorsIndexRoute: typeof ConnectorsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/architecture': {
      id: '/architecture'
      path: '/architecture'
      fullPath: '/architecture'
      preLoaderRoute: typeof ArchitectureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-sources': {
      id: '/data-sources'
      path: '/data-sources'
      fullPath: '/data-sources'
      preLoaderRoute: typeof DataSourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org-chart': {
      id: '/org-chart'
      path: '/org-chart'
      fullPath: '/org-chart'
      preLoaderRoute: typeof OrgChartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/podcasts': {
      id: '/podcasts'
      path: '/podcasts'
      fullPath: '/podcasts'
      preLoaderRoute: typeof PodcastsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills': {
      id: '/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof SkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/$agentType': {
      id: '/agent/$agentType'
      path: '/agent/$agentType'
      fullPath: '/agent/$agentType'
      preLoaderRoute: typeof AgentAgentTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connectors/': {
      id: '/connectors/'
      path: '/connectors'
      fullPath: '/connectors/'
      preLoaderRoute: typeof ConnectorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connectors/retrieval-paths': {
      id: '/connectors/retrieval-paths'
      path: '/connectors/retrieval-paths'
      fullPath: '/connectors/retrieval-paths'
      preLoaderRoute: typeof ConnectorsRetrievalPathsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hr/screener': {
      id: '/hr/screener'
      path: '/hr/screener'
      fullPath: '/hr/screener'
      preLoaderRoute: typeof HrScreenerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/it/signature': {
      id: '/it/signature'
      path: '/it/signature'
      fullPath: '/it/signature'
      preLoaderRoute: typeof ItSignatureRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgentsRoute: AgentsRoute,
  ArchitectureRoute: ArchitectureRoute,
  DataSourcesRoute: DataSourcesRoute,
  OrgChartRoute: OrgChartRoute,
  PodcastsRoute: PodcastsRoute,
  ProjectsRoute: ProjectsRoute,
  SkillsRoute: SkillsRoute,
  AgentAgentTypeRoute: AgentAgentTypeRoute,
  ConnectorsRetrievalPathsRoute: ConnectorsRetrievalPathsRoute,
  HrScreenerRoute: HrScreenerRoute,
  ItSignatureRoute: ItSignatureRoute,
  ConnectorsIndexRoute: ConnectorsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
